import {hrmsWithPath} from "../../services/http/api/rest";

const rest = hrmsWithPath("/v1/user");

const user = {
    search: (data?: any, pageNumber?: number, pageSize?: number) => rest.post('/search', {}, data, {
        "page-number": pageNumber,
        "page-size": pageSize
    }),
    create: (data: any) => rest.post('', {}, data, {}),
    update: (data: any, id: string) => rest.put('/{{id}}', {id}, data, {}),
    getById: (id: string) => rest.get('/{{id}}', {id}),
    getByEmail: (email: string) => rest.get('', {}, {'email': email}),
    findByRoleType: (roleType: string) => rest.get('/find', {}, {'role-type': roleType}),
    countByRole: () => rest.get('/count-by-role'),
    getUsers: (user: string | null) => rest.get(`/find?role-type={{user}}`, {user}, {}),
    markInactive: (userID: string) => rest.put(`/{{userID}}/inactive`, {userID}, {}, {}),
    sendCredentialEmail: (id: string) => rest.put(`/{{id}}/send-email`, {id}, {}, {}),
    changeStatus: (id: string, active: boolean) => rest.put('/{{id}}', {}, {}, {'active': active}),
    assignRole: (id: string, role: string) => rest.put('/{{id}}/assign/role', {id}, {}, {'type': role}),
    delete: (id: string) => rest.del('/{{id}', {id}),   //not in use
    changePassword: (data: object, id: string) => rest.put('/{{id}}/change-password', {id}, data, {}),
    userLoginDetail: (mail: any) => rest.get(`?email={{mail}}`, {mail}, {}),
}

export default user;